import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section
      id="vision"
      data-testid="hero-section"
      className="relative overflow-hidden bg-navy text-cream min-h-[100vh] flex items-end dark-section"
    >
      <div className="absolute inset-0 bg-lattice-dark opacity-60" />
      <div className="absolute -top-32 -right-32 w-[720px] h-[720px] chakra-radial opacity-50 orbit-slow rounded-full" />
      <div className="absolute bottom-[-120px] left-[-80px] w-[520px] h-[520px] chakra-radial opacity-30 orbit-reverse rounded-full" />

      {/* node network */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1400 900" preserveAspectRatio="xMidYMid slice" aria-hidden>
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="b" />
            <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        {[
          { x1: 1080, y1: 220, x2: 1260, y2: 380, c: "#D95D39" },
          { x1: 1080, y1: 220, x2: 980, y2: 460, c: "#4C956C" },
          { x1: 1260, y1: 380, x2: 980, y2: 460, c: "#0077B6" },
          { x1: 980, y1: 460, x2: 1180, y2: 640, c: "#D95D39" },
          { x1: 1260, y1: 380, x2: 1320, y2: 600, c: "#4C956C" },
          { x1: 1180, y1: 640, x2: 1320, y2: 600, c: "#0077B6" },
        ].map((l, i) => (
          <line key={i} {...l} stroke={l.c} strokeWidth="1.2" strokeOpacity="0.55" className="connective-line"
                style={{ animationDelay: `${0.2 + i * 0.15}s` }} />
        ))}
        {[
          { cx: 1080, cy: 220, r: 10, f: "#D95D39", label: "Demand" },
          { cx: 1260, cy: 380, r: 8, f: "#4C956C", label: "Knowledge" },
          { cx: 980, cy: 460, r: 9, f: "#0077B6", label: "Delivery" },
          { cx: 1180, cy: 640, r: 6, f: "#D95D39" },
          { cx: 1320, cy: 600, r: 6, f: "#4C956C" },
        ].map((n, i) => (
          <g key={i} className="pulse-node" style={{ animationDelay: `${i * 0.4}s` }}>
            <circle cx={n.cx} cy={n.cy} r={n.r + 6} fill={n.f} opacity="0.18" />
            <circle cx={n.cx} cy={n.cy} r={n.r} fill={n.f} filter="url(#glow)" />
            {n.label && (
              <text x={n.cx + 18} y={n.cy + 4} fill="#F8F9FA" fontSize="11" fontFamily="IBM Plex Mono"
                    letterSpacing="2" opacity="0.8">{n.label.toUpperCase()}</text>
            )}
          </g>
        ))}
      </svg>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pb-20 pt-36 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            <div data-testid="hero-eyebrow" className="font-mono-data text-xs tracking-[0.3em] uppercase text-terracotta mb-6 fade-up" style={{animationDelay:'.05s'}}>
              Blueprint · Digital Public Infrastructure
            </div>
            <h1 data-testid="hero-title"
                className="font-serif-display text-5xl sm:text-6xl lg:text-[88px] leading-[0.95] tracking-tight fade-up"
                style={{animationDelay:'.15s'}}>
              The institutional<br />
              <span className="italic text-[#E8B298]">backbone</span> for India's<br />
              capacity building <span className="text-terracotta">ecosystem.</span>
            </h1>
            <p data-testid="hero-sub"
               className="mt-8 max-w-2xl text-lg text-cream/75 leading-relaxed fade-up"
               style={{animationDelay:'.35s'}}>
              UNNATI is a connective intelligence layer that stitches training demand, programme delivery
              and institutional knowledge into one continuously improving system — across every CSTI,
              ATI and departmental institute.
            </p>
            <div className="mt-10 flex flex-wrap gap-4 fade-up" style={{animationDelay:'.5s'}}>
              <Link to="/platform" data-testid="hero-cta-platform"
                    className="inline-flex items-center gap-3 bg-terracotta text-white px-6 py-3.5 font-medium hover:bg-[#c44e2e]">
                Explore the Platform <span>→</span>
              </Link>
              <a href="#loop" data-testid="hero-cta-engine"
                 className="inline-flex items-center gap-3 border border-cream/25 text-cream px-6 py-3.5 font-medium hover:bg-cream/5">
                See the Learning Engine
              </a>
            </div>
          </div>
          <div className="lg:col-span-4 fade-up" style={{animationDelay:'.55s'}}>
            <div className="border-t border-cream/15 pt-6 space-y-6">
              {[
                ["74", "Training institutes onboarded"],
                ["1,82,450", "Officials trained & tracked"],
                ["312", "Competency-linked programmes live"],
              ].map(([k, v]) => (
                <div key={v} className="flex items-baseline gap-4">
                  <span className="font-mono-data text-3xl text-terracotta">{k}</span>
                  <span className="text-sm text-cream/70">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
